export function useShowMe() {
  const handleShowMe = (context) => {
    if (["/", "/settings", "/plans"].includes(location.pathname)) {
      if (context.currentBranch) {
        if (context.currentBranch.branch_plan) {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  return handleShowMe;
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/CardUpgrade/hooks/index.js